var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUsdsWithInfo = function SvgUsdsWithInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 28 41"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeOpacity: 0.3,
    strokeWidth: 3.832,
    d: "M25.897 10.539c0-2.874-3.832-8.623-11.497-8.623m0 0c-7.665 0-11.95 3.465-12.455 9.581-.502 6.07 5.748 9.581 10.539 11.497s7.665 4.79 7.665 7.665-.959 7.665-7.665 7.665M14.4 1.916c-3.483.274-6.625 3.15-5.748 7.665.93 4.79 8.622 8.623 8.622 8.623s8.313 4.556 8.623 9.58c.411 6.65-5.777 10.54-13.413 10.54m0 0c-5.365 0-10.54-6.707-10.54-8.623"
  })));
};
export default SvgUsdsWithInfo;